import { Link, NavLink } from "react-router-dom";
import { useState } from "react";

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const links = ["home", "gallery", "about", "press", "contact"];

    return (
        <header className="text-center relative">
            {/* Меню для мобильных сверху логотипа */}
            <div className="md:hidden mt-2">
            <span
                className="uppercase text-sm tracking-widest cursor-pointer hover:opacity-70 transition"
                onClick={() => setMenuOpen(prev => !prev)}
            >
              Menu
            </span>

                {/* Выпадающее меню */}
                <div
                    className={`overflow-hidden transition-all duration-300 mt-2 ${
                        menuOpen ? "max-h-96" : "max-h-0"
                    }`}
                >
                    <ul className="flex flex-col items-center gap-2 text-sm uppercase text-gray-600 tracking-widest">
                        {links.map((item, index) => (
                            <li
                                key={item}
                                className={`w-full text-center transform transition-all duration-300 ${
                                    menuOpen
                                        ? "translate-y-0 opacity-100"
                                        : "-translate-y-2 opacity-0"
                                }`}
                                style={{ transitionDelay: `${index * 75}ms` }}
                            >
                                <NavLink
                                    to={item === "home" ? "/" : `/${item}`}
                                    onClick={() => setMenuOpen(false)}
                                    className={({ isActive }) =>
                                        isActive
                                            ? "text-black font-medium"
                                            : "hover:text-black transition"
                                    }
                                >
                                    {item}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Логотип */}
            <div className="mt-2 md:mt-16 pt-1 pb-6 md:py-6">
                <Link
                    to="/"
                    className="text-6xl font-light tracking-widest uppercase hover:opacity-80 transition"
                >
                    Dinara Fariz
                </Link>
            </div>

            {/* Горизонтальная линия и nav для больших экранов */}
            <div className="hidden md:flex items-center justify-center gap-8 max-w-6xl mx-auto px-8 mt-5">
                <div className="h-px flex-1 bg-gray-300" />
                <nav className="flex gap-8 text-sm uppercase text-gray-600 tracking-[0.25em]">
                    {links.map(item => (
                        <NavLink
                            key={item}
                            to={item === "home" ? "/" : `/${item}`}
                            className={({ isActive }) =>
                                `pb-1 border-b transition-all duration-200 ${
                                    isActive
                                        ? "border-black text-black"
                                        : "border-transparent hover:border-gray-400"
                                }`
                            }
                        >
                            {item}
                        </NavLink>
                    ))}
                </nav>
                <div className="h-px flex-1 bg-gray-300" />
            </div>
        </header>
    );
};

export default Header;